"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "la-valletta-brianza": {
    "cbd32490": [{
      "hkey": "4bdb6bc3",
      "slug": "mulino",
      "name": "Mulino",
      "primary": true,
      "skipSearch": false
    }],
    "molino": [{
      "hkey": "4bdb6bc3",
      "slug": "mulino",
      "name": "Mulino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b87f35ad": [{
      "hkey": "12d7ffcb",
      "slug": "sara-casternago",
      "name": "Sara-Casternago",
      "primary": true,
      "skipSearch": false
    }],
    "sara": [{
      "hkey": "12d7ffcb",
      "slug": "sara-casternago",
      "name": "Sara-Casternago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f4dadedb": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "albareda": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09c5cf58": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "barbatella": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c7ebf8d9": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "brugolone": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ce837757": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "casternago": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d36a61e1": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "cere": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "afaab452": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "filatoio": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa0daaba": [{
      "hkey": "0a7fcc91",
      "slug": "fornace",
      "name": "Fornace",
      "primary": true,
      "skipSearch": false
    }],
    "fornace-alta": [{
      "hkey": "0a7fcc91",
      "slug": "fornace",
      "name": "Fornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "8d8cd975": [{
      "hkey": "0a7fcc91",
      "slug": "fornace",
      "name": "Fornace",
      "primary": true,
      "skipSearch": false
    }],
    "fornace-bassa": [{
      "hkey": "0a7fcc91",
      "slug": "fornace",
      "name": "Fornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "la-valletta-brianza"
    }],
    "3193bbb3": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "francolino": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fa220071": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "galbusera-bianca": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3582fa9b": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "skipSearch": false
    }],
    "zerbine": [{
      "hkey": "4ef14268",
      "slug": "la-valletta-brianza",
      "name": "La Valletta Brianza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;